module.exports = "<h2 mat-dialog-title class=\"headerStyleCustom\">Description</h2>\r\n<mat-dialog-content>\r\n  <div class=\"container\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12 col-md-12 col-lg-12\">\r\n        <p>{{Description}}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</mat-dialog-content>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Venkat Projects/sagiam-tool-angular/src/app/Dashboard/manage-events/description.html
// module id = ../../../../../src/app/Dashboard/manage-events/description.html
// module chunks = main